export const splitToArray = (
    string: string | null | undefined,
    separator?: string
): string[] => (string || '').split(separator ?? ',').filter((part) => !!part)
